import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PermissionService {

  private readonly permissionSetSubject = new BehaviorSubject<any>(null);
  public permissionSet$: Observable<any> = this.permissionSetSubject.asObservable();
  private readonly spPermissionSetSubject = new BehaviorSubject<any>(null);
  public spPermissionSet$: Observable<any> = this.spPermissionSetSubject.asObservable();

  constructor(private readonly http: HttpClient) { }

  getUserPermissions(roleId: number): Observable<any[]> {

    return this.http.get<any[]>(`Account/GetPermissions/${roleId}`).pipe(
      tap((result) => {

        this.permissionSetSubject.next(result);

        localStorage.setItem(
          'UserPermissions',
          JSON.stringify(result)
        );

        const tempValue = result.filter(
          f => f.area === 'Billing'
        );

        if (!tempValue.length) {
          return;
        }

        const privilege = JSON.parse(
          tempValue[0].privilege
        );

        if (
          privilege.filter(
            f =>
              f.Key === 'UnconditionalApproval' ||
              f.Key === 'ConditionalApproval'
          ).length < 1
        ) {
          localStorage.setItem(
            'UnconditionalApproval',
            'False'
          );

          localStorage.setItem(
            'ConditionalApproval',
            'False'
          );
        }

        for (const element of privilege) {

          if (
            element.Key === 'UnconditionalApproval'
          ) {
            localStorage.setItem(
              'UnconditionalApproval',
              element.Value
            );
          }
          else if (
            element.Key === 'ConditionalApproval'
          ) {
            localStorage.setItem(
              'ConditionalApproval',
              element.Value
            );
          }
        }
      })
    );
  }

  getSPUserPermission(siteId: number): Observable<any> {
    if (this.spPermissionSetSubject.value) {
      return of(this.spPermissionSetSubject.value); // Return cached permissions
    }

    return this.GetSPUserPermission(siteId).pipe(
      tap((res: any) => {
        if (res.statusCode === 200) {
          const spUserPermissions = JSON.parse(res.httpResponse);
          if (spUserPermissions.length > 0) {
            const userPermission = spUserPermissions[0];
            this.spPermissionSetSubject.next(userPermission); // Emit new permission set
          }
        }
      }),
      map(() => this.spPermissionSetSubject.value) // Ensure the latest value is returned
    );
  }

  resetSPPermissions(): void {
    this.spPermissionSetSubject.next(null);
  }

  GetSPUserPermission(siteId: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    const url = `api/datamssiterole/GetUserPermission/${siteId}`;
    return this.http.get<any>(url, { headers: headers });
  }
}
